import { useState } from "react";
import HTML from "../../../assets/html.webp";
import CSS from "../../../assets/css.webp";
import JavaScript from "../../../assets/javascript.webp";
import React from "../../../assets/react.webp";
import Angular from "../../../assets/angular.webp";
import Vue from "../../../assets/vue.webp";
import Angular2 from "../../../assets/angular2.webp";
import Kotlin from "../../../assets/kotlin.webp";
import Python from "../../../assets/python.webp";
import Django from "../../../assets/django.webp";
import Flutter from "../../../assets/flutter.webp";
import Node from "../../../assets/node.webp";
import Laravel from "../../../assets/node.webp";
import Java from "../../../assets/java.webp";
import PHP from "../../../assets/php.webp";
import GraphQL from "../../../assets/graph.webp";
import Express from "../../../assets/express.webp";
import Typescript from "../../../assets/typescript.webp";
import MySql from "../../../assets/mysql.webp";
import Mongo from "../../../assets/mongo.webp";


const Development = () => {
  const [areas, setAreas] = useState({
    web: true,
    mobile: false,
    backend: false,
    platform: false,
    ecommerce: false,
  });

//   const handleChange = (area) => {
//     if (area === "web") {
//       setAreas({
//         web: true,
//         mobile: false,
//         backend: false,
//         platform: false,
//         ecommerce: false,
//       });
//     } else if (area === "mobile") {
//       setAreas({
//         web: false,
//         mobile: true,
//         backend: false,
//         platform: false,
//         ecommerce: false,
//       });
//     } else if (area === "backend") {
//       setAreas({
//         web: false,
//         mobile: false,
//         backend: true,
//         platform: false,
//         ecommerce: false,
//       });
//     } else if (area === "platform") {
//       setAreas({
//         web: false,
//         mobile: false,
//         backend: false,
//         platform: true,
//         ecommerce: false,
//       });
//     } else {
//       setAreas({
//         web: false,
//         mobile: false,
//         backend: false,
//         platform: false,
//         ecommerce: true,
//       });
//     }
//   };

  return (
    <div className="development">
      <div className="inner">
        <div className="title">
          <h4>Our Development Proficiencies</h4>
          <div className="dash"></div>
        </div>
        {/* <div className="areas">
                    <h5 className={areas.web ? "active" : ""} onClick={() => handleChange("web")}>Web</h5>
                    <h5 className={areas.mobile ? "active" : ""} onClick={() => handleChange("mobile")}>Mobile</h5>
                    <h5 className={areas.backend ? "active" : ""} onClick={() => handleChange("backend")}>Backend</h5>
                    <h5 className={areas.platform ? "active" : ""} onClick={() => handleChange("platform")}>Platform</h5>
                    <h5 className={areas.ecommerce ? "active" : ""} onClick={() => handleChange("ecommerce")}>Ecommerce</h5>
                </div> */}
        {areas.web && (
          <div className="stacks">
            <img src={HTML} alt="Stack" />
            <img src={CSS} alt="Stack" />
            <img src={JavaScript} alt="Stack" />
            <img src={React} alt="Stack" />
            <img src={Node} alt="Stack" />
            <img src={Express} alt="Stack" />
            <img src={Python} alt="Stack" />
            <img className="align" src={Django} alt="Stack" />
            <img className="align" src={PHP} alt="Stack" />
            <img className="align" src={Typescript} alt="Stack" />
            <img className="align" src={MySql} alt="Stack" />
            <img className="align" src={Mongo} alt="Stack" />
            {/* <img className="align" src={Angular} alt="Stack" /> */}
            {/* <img className="align" src={Vue} alt="Stack" /> */}
          </div>
        )}

        {areas.mobile && (
          <div className="stacks">
            <img src={React} alt="Stack" />
            <img src={Flutter} alt="Stack" />
            <img src={Java} alt="Stack" />
            <img src={JavaScript} alt="Stack" />
            <img className="align" src={Angular2} alt="Stack" />
            <img className="align" src={Kotlin} alt="Stack" />
          </div>
        )}

        {areas.backend && (
          <div className="stacks" onClick={() => setAreas({
            web: true,
            mobile: false,
            backend: false,
            platform: false,
            ecommerce: false})}>
            <img src={Python} alt="Stack" />
            <img src={Node} alt="Stack" />
            <img src={Java} alt="Stack" />
            <img src={JavaScript} alt="Stack" />
            <img className="align" src={Django} alt="Stack" />
            <img className="align" src={Laravel} alt="Stack" />
          </div>
        )}

        {areas.platform && (
          <div className="stacks">
            <img src={Angular} alt="Stack" />
            <img src={Vue} alt="Stack" />
            <img src={React} alt="Stack" />
            <img src={Node} alt="Stack" />
            <img className="align" src={PHP} alt="Stack" />
            <img className="align" src={GraphQL} alt="Stack" />
          </div>
        )}

        {areas.ecommerce && (
          <div className="stacks">
            <img src={React} alt="Stack" />
            <img src={Angular} alt="Stack" />
            <img src={CSS} alt="Stack" />
            <img src={Node} alt="Stack" />
            <img className="align" src={Django} alt="Stack" />
            <img className="align" src={Laravel} alt="Stack" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Development;
